import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        // ======================
        // Blank Layout
        // ======================
        {
            path: "",
            component: () => import("./layout/blank/Blank.vue"),
            // ======================
            // Theme routes / pages
            // ======================
            children: [
                {
                    path: '/',
                    redirect: '/service'
                },
                {
                    path: '/service',
                    name: "ServiceList",
                    index: 0,
                    component: () => import("./views/ServiceList.vue"),
                },
                {
                    path: '/service/:slug',
                    name: "Service",
                    index: 0,
                    component: () => import("./views/Service.vue"),
                },
            ],
        },
       
        // Redirect to starterkit page, if no match found
        {
            path: '*',
            redirect: '/service'
        }
    ]
})